module.exports = __webpack_public_path__ + "img/Snipaste_54.6c6b4fe5.png";